function randomItem(list) {
  return list[Math.floor(Math.random() * list.length)];
}

function newChallengeId() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

function makeGesture() {
  return {
    direction: randomItem(['ltr', 'rtl']),
    confirmRatio: 0.82,
  };
}

function withDistinctDirections(challenge) {
  if (!challenge.buy || !challenge.sell) return challenge;
  if (challenge.buy.direction === challenge.sell.direction) {
    return {
      ...challenge,
      sell: {
        ...challenge.sell,
        direction: challenge.sell.direction === 'ltr' ? 'rtl' : 'ltr',
      },
    };
  }
  return challenge;
}

export function createSwipeChallenge({ hasBuy = false, hasSell = false } = {}) {
  const order = [];
  if (hasSell) order.push('sell');
  if (hasBuy) order.push('buy');

  return withDistinctDirections({
    id: newChallengeId(),
    order,
    buy: hasBuy ? makeGesture() : null,
    sell: hasSell ? makeGesture() : null,
  });
}

export function rerollSwipeGestures(challenge, { hasBuy = false, hasSell = false } = {}) {
  return createSwipeChallenge({ hasBuy, hasSell });
}
